import Paper, { PaperProps } from "@mui/material/Paper";

/**
 * Static layout element for creating surfaces with backgrounds, borders, and elevation.
 *
 * For interactive elements representing entities in the app (e.g., class cards, activity cards),
 * use the Card component instead.
 *
 * This is a re-export of the [MUI Paper component](https://mui.com/material-ui/api/paper/).
 *
 * @example
 * ```tsx
 * <Paper elevation={1} sx={{ padding: 2, borderRadius: 1 }}>
 *   <Typography>Static content container</Typography>
 * </Paper>
 * ```
 */
export default Paper;
export type { PaperProps };
